import { Address } from '../types/CommonTypes'

export const EMPTY_ADDRESS: Address = {
  streetAddress: [''],
  city: '',
  postalCode: '',
  state: '',
  country: '',
}
